import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { Query, Mutation } from 'react-apollo';
import { AccountContext } from '../../../../components/AccountContext';
import { Loading } from '../../../../components/Loading';
import AssessmentTempNew from './AssessmentTempNew';

const FORM_META_QUERY = gql`
  query($accountId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      assessmentSections {
        behaviorSection {
          displayName
          dimensions {
            name
            displayName
            questionnaireLanguages
            jpsLanguages
            reportLanguages
          }
          distortion: distortionDimensions {
            name
            displayName
            questionnaireLanguages
            jpsLanguages
            reportLanguages
          }
        }
        cognitiveSection {
          displayName
          dimensions {
            name
            displayName
            questionnaireLanguages
            jpsLanguages
            reportLanguages
          }
        }
        interestsSection {
          displayName
          dimensions {
            name
            displayName
            questionnaireLanguages
            jpsLanguages
            reportLanguages
          }
        }
      }
      communicationTemplates(first: $first) {
        edges {
          node {
            id
            name
            type
          }
        }
      }
    }
  }
`;

const ADD_NEW_ASSESSMENT_TEMP = gql`
  mutation($input: CreateAssessmentTemplateInput!) {
    createAssessmentTemplate(input: $input) {
      template {
        id
      }
    }
  }
`;

const AssessmentTempNewContainer = () => {
  const currentAccount = useContext(AccountContext);

  return (
    <Query
      query={FORM_META_QUERY}
      variables={{
        accountId: currentAccount,
        first: 200,
      }}
    >
      {({ loading, error, data }) => {
        if (loading) return <Loading />;
        if (error) return `Error! ${error.message}`;

        return (
          <Mutation mutation={ADD_NEW_ASSESSMENT_TEMP}>
            {(addTemp) => <AssessmentTempNew data={data} addTemp={addTemp} />}
          </Mutation>
        );
      }}
    </Query>
  );
};

export default AssessmentTempNewContainer;
